<template>
    <b-container>
        <b-row class="main-content" align-v="center" align-h="center">
            <b-row align-h="center" class="w-100">
                <Spinner
                :loading='this.fetching' 
                :offline='this.error'
                @retry-action="fetchProfile()"
                />
                <b-card
                style="max-width: 20rem;margin-top:14px;width:90%"
                class="mb-2"
                body-class="text-center"
                :class="{'hide':this.fetching || this.error}"
                >
                    <b-card-title>{{this.userInfo.name}}  <b-badge pill variant="success" id="lvBadge">{{character}}</b-badge></b-card-title>
                    <b-card-text>
                        手机: {{this.userInfo.phone}} <br>
                        <!-- 邮箱: {{this.userInfo.name}} <br> -->
                    </b-card-text>
                    <b-button block @click="logoutConfirm()" variant="primary">注销</b-button>
                </b-card>
            </b-row>
        </b-row>
    </b-container>
</template>

<style>

</style>

<script>
import Spinner from '../components/LoadingSpinner.vue'
import {auth} from '../components/auth'
import {urls} from '../components/urls'

export default {
    name:'profile',
    components:{
        Spinner
    },
    mixins:[auth,urls],
    data:function(){
        return{
            fetching:true,
            disableBtn:false,
            error:false,
        }
    },
    methods: {
        fetchProfile:function(){
            this.$axios.get(this.fetchUrl+"/api/user/"+this.userInfo.uid,{headers: { "Authorization" : this.header}})
            .then(res=>{
                this.error=false;
                this.fetching=false;
                this.updateInfo(res.data);
            })
            .catch(error => {
                this.error=true;
                this.fetching=false;
                if (error.response) {
                    // The request was made and the server responded with a status code
                    // that falls out of the range of 2xx
                    console.log(error.response.data);
                    console.log(error.response.status);
                    console.log(error.response.headers);
                } else if (error.request) {
                    // The request was made but no response was received
                    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                    // http.ClientRequest in node.js
                    console.log(error.request);
                } else {
                    // Something happened in setting up the request that triggered an Error
                    console.log('Error', error.message);
                }
                console.log(error.config);
            });
        },
        logoutConfirm:function(){
            this.$bvModal.msgBoxConfirm('确认退出？', {
            title: '请确认',
            size: 'lg',
            buttonSize: 'lg',
            okVariant: 'danger',
            okTitle: '确认',
            cancelTitle: '取消',
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true
            })
            .then(value => {
                if(value === true){
                    this.logout();
                }
            })
            .catch(err => {
                // An error occurred
            })
        }
    },
    computed:{
        character(){
            switch(this.userInfo.admin){
                case 0:
                    return '用户';
                case 1:
                    return '管理员'
                default:
                    return '未知'
            }
        }
    },
    mounted(){
        this.fetchProfile();
    }
}
</script>

